import React, { useState } from 'react';
import ArrowNextIconSVG from '../../assets/icons/svg/ArrowNextIconSVG';

const Verify = ({ onClose, onVerify, errorMessage }) => {
  const [values, setValues] = useState(["", "", "", "", "", ""]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/[0-9]/.test(value)) {
      const newValues = [...values];
      newValues[index] = value;
      setValues(newValues);
      
      if (index < values.length - 1) {
        document.getElementById(`input-${index + 1}`).focus();
      }
    }
  };

  const isFormComplete = values.every(v => v !== "");

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h3 style={styles.title}>Verifikacija telefona</h3>
        <p style={styles.subtitle}>
          Unesi aktivacioni kod koji ti je stigao putem SMS poruke:
        </p>
        <div style={styles.inputRow}>
          {values.map((value, i) => (
            <React.Fragment key={i}>
              <input
                id={`input-${i}`}
                maxLength="1"
                style={styles.input}
                value={value}
                onChange={e => handleChange(e, i)}
              />
              {i < values.length - 1 && <span style={styles.dash}>-</span>}
            </React.Fragment>
          ))}
        </div>
        {errorMessage && <div style={styles.error}>{errorMessage}</div>}
        <p style={styles.paragraph}>Nisi dobio kod?</p>
        <span style={styles.link}>Zahtevaj kod ponovo</span>
        <div style={styles.buttonRow}>
          <button onClick={onClose} style={styles.cancelButton}>
            Odustani
          </button>
          <button
            onClick={() => onVerify(values.join(""))}
            disabled={!isFormComplete}
            style={isFormComplete ? styles.sendButton : styles.sendButtonDisabled}
          >
            <span style={styles.buttonText}>Pošalji</span>
              <ArrowNextIconSVG />
            
          </button>
        </div>
      </div>
    </div>
  );
};

export default Verify;

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: '#F9FAFB',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modal: {
    borderRadius: 8,
    padding: '40px 30px',
    width: 590,
    height: 430,
    textAlign: 'center',
    border: '1px solid rgba(23, 23, 24, 0.2)',
    backgroundColor: '#FFFFFF',
  },
  title: {
    fontSize: 24,
    fontWeight: 600,
    margin: 0,
    marginBottom: 20,
    color: 'rgba(0, 0, 0, 0.87)',
    lineHeight: '32px',
  },
  subtitle: {
    fontSize: 16,
    margin: 0,
    marginBottom: 30,
    color: 'rgba(0, 0, 0, 0.87)',
    lineHeight: '24px',
  },
  inputRow: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 30,
  },
  input: {
    width: 56,
    height: 56,
    fontSize: 20,
    textAlign: 'center',
    borderRadius: 8,
    border: '1px solid #ccc',
    margin: '0 5px',
    backgroundColor: '#FFFFFF',
  },
  dash: {
    margin: '0 3px',
    fontSize: 20,
    color: 'rgba(0, 0, 0, 0.6)',
    alignSelf: 'center',
  },
  error: {
    color: 'red',
    fontSize: '14px',
    marginTop: '10px',
  },
  paragraph: {
    display: 'inline',
    margin: 0,
    marginRight: 5,
    fontSize: 16,
    lineHeight: '24px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  link: {
    display: 'inline-flex',
    fontWeight: 700,
    fontSize: 16,
    lineHeight: '24px',
    color: '#7C3AED',
    cursor: 'pointer',
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'center',
    gap: 15,
    marginTop: 50,
  },
  cancelButton: {
    backgroundColor: '#FFFFFF',
    color: 'rgba(91, 33, 182, 1)',
    borderRadius: 8,
    padding: '10px 24px',
    fontSize: 20,
    cursor: 'pointer',
    border: 'none',
  },
  sendButton: {
    backgroundColor: '#000000',
    color: '#F3F3F3',
    borderRadius: 8,
    padding: '10px 24px',
    fontSize: 20,
    display: 'flex',
    alignItems: 'center',
    width: 150,
    cursor: 'pointer',
    border: 'none',
  },
  sendButtonDisabled: {
    backgroundColor: '#ccc',
    color: '#F3F3F3',
    borderRadius: 8,
    padding: '10px 24px',
    fontSize: 20,
    display: 'flex',
    alignItems: 'center',
    width: 150,
    cursor: 'not-allowed',
    border: 'none',
  },
  buttonText: {
    marginRight: '10px',
    fontWeight: 600,
  },

};
